import type { ApplicationVerifier } from 'firebase/auth';
import { FirebaseError } from 'firebase/app';
import { firebaseAuthService } from '@/core/services';
import type { ConfirmationResult } from '@/core/services';

export class ReenviarOtpVincularTelefoneUseCase {
  async execute(
    phoneNumber: string,
    appVerifier: ApplicationVerifier
  ): Promise<ConfirmationResult> {
    const user = firebaseAuthService.getAuth().currentUser;
    if (!user) {
      throw new FirebaseError('auth/no-current-user', 'Nenhum usuário autenticado.');
    }
    return firebaseAuthService.resendVerificationCodeToLinkPhone(
      user,
      phoneNumber,
      appVerifier
    );
  }
}
